import * as yup from 'yup';

export function isValidCPF(cpf: string): boolean {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let sum = 0;
  let remainder: number;
  for (let i = 0; i < 9; i += 1) sum += parseInt(cpf.charAt(i), 10) * (10 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.charAt(9), 10)) return false;
  sum = 0;
  for (let i = 0; i < 10; i += 1) sum += parseInt(cpf.charAt(i), 10) * (11 - i);
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.charAt(10), 10)) return false;
  return true;
}

export const validateCPFInput = yup
  .string()
  .required('Campo obrigatório')
  .test({
    message: 'CPF Inválido',
    test: async (value) => {
      const characterCount = value?.includes('.') ? 14 : 11;
      return yup
        .string()
        .min(characterCount)
        .max(characterCount)
        .test({
          name: 'document',
          message: 'CPF Inválido',
          test: (document) => (document ? isValidCPF(document) : false),
        })
        .isValid(value);
    },
  });

export function isValidCNPJ(cnpj: string | number): boolean {
  const cnpjStr = String(cnpj).replace(/[^\d]+/g, '');
  if (cnpjStr.length !== 14) return false;
  if (/^(\d)\1+$/.test(cnpjStr)) return false;
  const calc = (val: string, len: number): number => {
    let sum = 0;
    let weight = len - 7;
    for (let i = 0; i < len; i += 1) {
      sum += parseInt(val.charAt(i), 10) * weight;
      weight -= 1;
      if (weight < 2) weight = 9;
    }
    const result = 11 - (sum % 11);
    return result >= 10 ? 0 : result;
  };
  const base = cnpjStr.slice(0, 12);
  const d1 = calc(base, 12);
  const d2 = calc(base + d1, 13);
  return (
    d1 === parseInt(cnpjStr.charAt(12), 10) &&
    d2 === parseInt(cnpjStr.charAt(13), 10)
  );
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export function isValidDocument(doc: string): boolean {
  const digits = doc.replace(/\D/g, '');
  if (digits.length === 11) return isValidCPF(digits);
  if (digits.length === 14) return isValidCNPJ(digits);
  return false;
}

export const regexDate =
  /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
